import React from 'react';

function Services() {
  const services = [
    {
      icon: '🚀',
      title: 'PHP Laravel Development',
      description: 'Robust, scalable web applications built with Laravel framework. Custom CMS, API development, and enterprise solutions.',
      features: ['Custom Applications', 'RESTful APIs', 'Enterprise Solutions']
    },
    {
      icon: '🌐',
      title: 'WordPress Development',
      description: 'Professional WordPress websites with custom themes, plugins, and optimized performance for your business needs.',
      features: ['Custom Themes', 'Plugin Development', 'SEO Optimization']
    },
    {
      icon: '🛒',
      title: 'Shopify E-commerce',
      description: 'Complete e-commerce solutions on Shopify. From store setup to custom themes and app integrations.',
      features: ['Store Setup', 'Custom Themes', 'App Integration']
    },
    {
      icon: '🎨',
      title: 'Wix Website Design',
      description: 'Beautiful, responsive websites using Wix platform. Perfect for small businesses and startups looking for quick deployment.',
      features: ['Responsive Design', 'Fast Deployment', 'Easy Management']
    },
    {
      icon: '📱',
      title: 'Hybrid Mobile Apps',
      description: 'Cross-platform mobile applications using React Native and Ionic. One codebase for iOS and Android.',
      features: ['iOS & Android', 'Native Performance', 'Cost Effective']
    },
    {
      icon: '💡',
      title: 'Custom Web Solutions',
      description: 'Tailored web solutions using modern technologies. React, Vue, Angular, and full-stack development services.',
      features: ['Modern Stack', 'Scalable Architecture', 'Cloud Integration']
    }
  ];

  return (
    <section id="services" className="services">
      <div className="services-container">
        <div className="services-header">
          <div className="section-label">WHAT WE DO</div>
          <h2 className="services-title">Our Services</h2>
          <p className="services-subtitle">
            Full-stack development solutions for modern businesses
          </p>
        </div>
        <div className="services-grid">
          {services.map((service, index) => (
            <div key={index} className="service-card">
              <div className="service-header">
                <div className="service-icon">{service.icon}</div>
                <h3 className="service-title">{service.title}</h3>
              </div>
              <p className="service-description">{service.description}</p>
              <div className="service-features">
                {service.features.map((feature, idx) => (
                  <span key={idx} className="feature-tag">{feature}</span>
                ))}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default Services;
